// extracted by mini-css-extract-plugin
module.exports = {"dialogue-view":"dialogue-m__dialogue-view__1NV_C"};